import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import styles from './styles.less';
import SubscribeComponent from '../../TinyComponents/SubscribeComponent';

const SubscribeCourses = ({ course, onSubmit, user }) => {
  const { locale } = React.useContext(LocalizationContext);
  return (
    <div className={styles.subscribeCoursesContainer}>
      <div className={styles.textWrapper}>
        <h2>{course.category[`subscribe_category_title_${locale}`]}</h2>
        <p>{course.category[`subscribe_category_text_${locale}`]}</p>
      </div>
      <div className={styles.subscribeEmailWrapper}>
        <SubscribeComponent
          subscribeName="subscribeList"
          course={course}
          user={user}
          onSubmit={onSubmit}
        />
      </div>
    </div>
  );
};

SubscribeCourses.propTypes = {
  course: PropTypes.object,
  onSubmit: PropTypes.func,
  user: PropTypes.object,
};
SubscribeCourses.defaultProps = {
  onSubmit: () => {},
  course: {},
  user: {},
};

export default SubscribeCourses;
